/**
 * Created by mauget on 3/25/16.
 */

import BaseController from 'BaseController';
import constants from 'Constants.js';
import listService from 'ListService.js';
import groupService from 'GroupService.js';
import undoService from 'UndoService.js'
import GroupControlView from 'common-visuals/GroupControlView.js';
import textConstants from 'TextConstants';
import Spinner from 'spin/spin';

//=================================================================================================
// Initially created to support the Group/ungroup context menu:
//
// If multiple controls selected, this code creates a general group control that visually
// surrounds them. It moves the selected controls into the group as their new containing parent.
//
// On the other hand, if only a group control is selected, toggleGroup() recognizes an ungroup 
// operation. It destroys the group control, moving the group's contained controls to the next-higher
// parent.
// (only the page supported, currently; nested groups need to be implemented).
//=================================================================================================
class GroupController extends BaseController {

    constructor() {
        super();
    }

    //===========================================================================================================
    // Does not proceed, doing nothing if selection count == 0;
    // (filter the form from the selected)
    //
    // If the selection count is === 1 and that single selection is a group, then this is an ungroup request
    //   1. Find each control having the selected groupId value ..
    //      a. Remove the group ID from it.
    //      b. Relocate the origin of the control from that of the group to that of the parent
    //      c. In the DOM, move the control to the parent of the group (either another group or the page)
    //
    // Otherwise this is a group request
    //   1. Create a "control-group" control, noting its group ID.
    //   2. Define a groupId of the control-group ID on each control view.
    //   3. Relocate the origin of the control from that of the parent (e.g. page) to that of the new group
    //   3. In the DOM, set the parent of each control view to be the control-group item.
    //===========================================================================================================
    toggleGroup(selectedMap) {

        // Which: group action or ungroup action requested?
        const selectedControls = selectedMap.filter((v, k) => v.id !== constants.FORM_RAW_ID);
        const selectedCount = selectedControls.size;

        // Ignore if nothing selected. UI shouldn't have called us anyway.
        if (!selectedCount) {
            return;
        }

        // Determine which toggle is next
        let isActionGroup = true;

        if (selectedCount === 1 && constants.GROUP_KEYS.contains(selectedControls.first().model.get('factoryKey'))) {
            isActionGroup = false; //Ungroup
        }

        const spin = new Spinner().spin($(constants.CONTENT_ID).get(0));
        $(constants.PAGE_ID).css({ opacity: 0.5 });
        setTimeout(() => {
            try {
                this.doToggleGroup(selectedControls, isActionGroup);
            }
            catch (err) {
                console.log(err);
            }
            finally {
                spin.stop();
                $(constants.PAGE_ID).css({ opacity: 1 });
            }
        }, 10);
    }

    doToggleGroup(selectedControls, isActionGroup) {
        let group, eventText, groupControls;
        if (isActionGroup) {
            group = groupService.groupControls('', selectedControls);
            eventText = textConstants.UNDO_ADD_GROUP;
            groupControls = selectedControls;
        } else {
            const selected = selectedControls.first();
            group = selected instanceof GroupControlView ? selected : listService.getObject(selected._groupId);
            groupControls = groupService.ungroupControls(selected);
            eventText = textConstants.UNDO_REMOVE_GROUP;
        }

        undoService.add({
            undo: () => {
                const spin = new Spinner().spin($(constants.CONTENT_ID).get(0));
                $(constants.PAGE_ID).css({ opacity: 0.5 });
                setTimeout(() => {
                    try {
                        isActionGroup ? groupService.ungroupControls(group) : groupService.groupControls(group, groupControls);
                    }
                    catch (err) {
                        console.log(err);
                    }
                    finally {
                        spin.stop();
                        $(constants.PAGE_ID).css({ opacity: 1 });
                    }
                }, 50);
            },
            redo: () => {
                const spin = new Spinner().spin($(constants.CONTENT_ID).get(0));
                $(constants.PAGE_ID).css({ opacity: 0.5 });
                setTimeout(() => {
                    try {
                        isActionGroup ? groupService.groupControls(group, groupControls) : groupService.ungroupControls(group);
                    }
                    catch (err) {
                        console.log(err);
                    }
                    finally {
                        spin.stop();
                        $(constants.PAGE_ID).css({ opacity: 1 });
                    }
                }, 50);
            }
        }, eventText);
    }

    
}

const groupController = new GroupController();
export default groupController;
